import React from "react";

const StateCard = ({ title, value, percentage, subtitle, icon, iconBg, mui }) => {
  const isPositive = percentage >= 0;

  return (
    <div className="bg-thirdly rounded-xl shadow-md p-4 flex flex-col justify-between min-w-[220px]">
      {/* Title */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg text-gray-300">{title}</h3>
        <div className={`${ mui ? "p-1" : "p-2" }   rounded-md ${iconBg}`}>{icon}</div>
      </div>

      {/* Value & Percentage */}
      <div className="mt-2">
        <h2 className="text-2xl font-bold text-white">
          {parseFloat(value)}
          <span
            className={`ms-2 text-sm font-semibold ${
              isPositive ? "text-green-500" : "text-red-500"
            }`}
          >
           {percentage != null ? (
              <span>
                ({percentage}%)
              </span>
            ) : null}
          </span>
        </h2>
      </div>

      {/* Subtitle */}
      <p className="text-sm text-gray-400 mt-2">{subtitle}</p>
    </div>
  );
};

export default StateCard;
